import type { ReactNode } from "react";
import { Flex } from "@jsq/ds/core";
import { Sizes } from "@jsq/ds/styles";
import * as styles from "./styles_vanilla.css";

export const WizardFooterBar = ({ children }: { children: ReactNode }) => (
  <Flex className={styles.footerInner} justifyContent="flex-end" gap={Sizes.SM}>
    {children}
  </Flex>
);
